import {
  toZonedTime,
  fromZonedTime,
  getTimezoneOffset as getTimezoneOffsetFns,
  formatInTimeZone as formatInTimeZoneFns,
  ToDateOptionsWithTZ,
} from 'date-fns-tz'
import { enUS } from 'date-fns/locale/en-US'

export const zonedTimeToUtc = (
  date: Date | string | number,
  timeZone: string,
  options?: ToDateOptionsWithTZ
) => {
  return fromZonedTime(date, timeZone, options)
}

export const convertTimezoneToLocal = (date: Date | number | string, timezone: string) => {
  return toZonedTime(date, timezone)
}

export const getTimezoneOffset = (timeZone: string, date?: Date | number) => {
  return getTimezoneOffsetFns(timeZone, date)
}

export const convertTimezone = (date: Date | number, timezone: string) => {
  return zonedTimeToUtc(date, timezone)
}

export const formatInTimeZone = (
  date: string | number | Date,
  timezone: string,
  format: string,
  forceUsLocale = false
) => {
  return formatInTimeZoneFns(date, timezone, format, forceUsLocale ? { locale: enUS } : undefined)
}
